import { CityLandingPage } from "../components/CityLandingPage";

export function WebdesignHoyerswerda() {
  return (
    <CityLandingPage city="Hoyerswerda" citySlug="hoyerswerda" variant="webdesign" />
  );
}
